"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemGroup = require("@/api/systemGroup");
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    linkaddress: _linkaddress.default
  },
  data: function data() {
    return {
      leftComponents: [{
        title: "基础型组件",
        list: [{
          title: "图片",
          type: "image",
          icon: "el-icon-picture-outline"
        }]
      }, {
        title: "商品组件",
        list: [{
          title: "产品",
          type: "goods",
          icon: "el-icon-goods"
        }]
      }],
      activity: {
        title: "" // 活动标题
      },
      centerComponents: [],
      selectType: null,
      // 当前选中组件类型
      activityId: null,
      // 活动ID
      currentActivityIndex: 0,
      // 当前活动索引
      currentActivityItemIndex: 0,
      // 当前活动项索引
      previewVisible: false
    };
  },
  created: function created() {
    // 获取活动详情
    this.activityId = this.$route.query.id;
    if (this.activityId) {
      this.getActivityPageDetail();
    }
  },
  methods: {
    // 获取活动详情
    getActivityPageDetail: function getActivityPageDetail() {
      var _this = this;
      (0, _systemGroup.getActivityPageDetail)({
        id: this.activityId
      }).then(function (data) {
        console.log(data, "获取活动详情");
        _this.activity.title = data.title;
        data.list.map(function (item, index) {
          // 处理商品组件的value字段
          if (item.type === 3 && item.value) {
            var value = JSON.parse(item.value);
            console.log(value, "value--------------------------");
            // 确保productList和product_id_list存在，否则初始化为空数组和空字符串
            item.product_list = value.product_list || [];
            item.product_id_list = value.product_id_list || [];
          }
          return _objectSpread(_objectSpread({}, item), {}, {
            select: false // 初始化选中状态
          });
        });
        _this.centerComponents = _toConsumableArray(data.list);
        console.log(_this.centerComponents, "centerComponents");
      });
    },
    // 添加组件到中心板
    addComponent: function addComponent(_item) {
      // 根据类型添加不同的默认模版
      var template = {};
      switch (_item.type) {
        case "image":
          template = {
            class: "image",
            type: 2,
            image: "",
            url: ""
          };
          break;
        case "goods":
          template = {
            class: "goods",
            type: 3,
            product_list: [],
            product_id_list: [],
            value: ""
          };
          break;
      }
      this.centerComponents.push(template);
    },
    // 删除组件
    deleteComponent: function deleteComponent(index) {
      this.centerComponents.splice(index, 1);
    },
    selectComponent: function selectComponent(index) {
      this.currentActivityIndex = index;
      // 先全部取消选中
      this.centerComponents.forEach(function (c, i) {
        return c.select = i === index;
      });
      // 右侧显示对应设置
      var current = this.centerComponents[index];
      switch (current.type) {
        case 2:
          this.selectType = "image";
          break;
        case 3:
          this.selectType = "goods";
          break;
        default:
          this.selectType = null;
      }
    },
    // 右侧属性变更
    handleRightChange: function handleRightChange(key, value) {
      // 同步右侧面板数据
      this.selectComponent(this.selectedIndex);
    },
    modalPicTap: function modalPicTap(tit, num, i, boolean) {
      var _this2 = this;
      this.$modalUpload(function (img) {
        console.log(img, "img-----------------------");
        _this2.centerComponents[i].image = img[0].sattDir;
      }, tit, "content", true);
    },
    changeGoods: function changeGoods(index) {
      var _this3 = this;
      console.log(this.centerComponents[index], "changeGoods");
      this.$modalGoodList(function (row) {
        _this3.$set(_this3.centerComponents[index], "product_list", _this3.centerComponents[index].product_list || []);
        _this3.$set(_this3.centerComponents[index], "product_id_list", _this3.centerComponents[index].product_id_list || []);
        console.log(_this3.centerComponents[index], "changeGoods2222222222");
        var exists = _this3.centerComponents[index].product_list.some(function (item) {
          return item.id === row.id;
        });
        if (exists) {
          _this3.$message.warning("该商品已存在，请勿重复添加");
          return;
        }
        _this3.centerComponents[index].product_list.push(row);
        _this3.centerComponents[index].product_id_list.push(row.id);
      });
    },
    getLink: function getLink(index) {
      this.currentActivityItemIndex = index;
      this.$refs.linkaddres.dialogVisible = true;
    },
    linkUrl: function linkUrl(e) {
      console.log(e, "linkUrl--------------------------");
      this.centerComponents[this.currentActivityItemIndex].url = e;
      console.log(this.centerComponents, "centerComponents--------------------------");
    },
    handleSave: function handleSave() {
      var _this4 = this;
      if (!this.activity.title) {
        this.$message.error("请填写活动标题");
        return;
      }
      var options = {
        id: this.activityId || null,
        // 如果有ID则更新，否则创建新活动
        title: this.activity.title,
        list: this.centerComponents
      };
      options.list = options.list.map(function (item) {
        if (item.type === 3) {
          var value = {
            product_list: item.product_list,
            product_id_list: item.product_id_list
          };
          item.value = JSON.stringify(value);
        }
        return item;
      });
      console.log(options, "options--------------------------");
      (0, _systemGroup.saveActivityPage)(options).then(function (res) {
        _this4.$message({
          type: "success",
          message: "保存成功!"
        });
        _this4.$router.push({
          name: "activityDesign"
        });
      });
    },
    handlePreview: function handlePreview() {
      this.previewVisible = true;
    }
  }
};